import MenuFrame from "../frames/menu_frame";
import { useState } from "react";
import { getAllOrgCn } from "./edit_halper";
import { Autocomplete, Box, Chip, Collapse, createTheme, FormControl, Grid, IconButton, InputLabel, Link, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, ThemeProvider, Typography } from "@mui/material";
import { AccountCircleTwoTone, Delete, Edit } from "@mui/icons-material";
import Loading1 from "../frames/loading1";
import { dateUsaToInd, getCurrentDate, getCurrentMonthStart } from "../frames/common";
import { blue, green, orange } from "@mui/material/colors";
import PriceEdit from "./price_edit";
import LocationEdit from "./location_edit";
import WeightEdit from "./weight_edit";
import DeleteConsignment from "./delete_consignment";
import DropDownLoading from "../frames/dropdown_loading";
import { getClientList } from "../booking/booking_halper";
import { useParams } from "react-router-dom";
import DateEdit from "./date_edit";

const cu_date = getCurrentDate();
let allCns = [];

function OrgCnEdit() {
    const [clientList, setClientList] = useState(null);
    const [consignmentList, setConsignmentList] = useState(null);
    const [activeConsignment, setActiveConsignment] = useState(null);
    const [spanTime, setSpanTime] = useState('month');
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [fieldEdit, setFieldtEdit] = useState(false);
    const params = useParams();
    const dayTheme = createTheme();

    const handleEditSuccess = (json) => {
        let index = -1;
        for (let idx = 0; idx < consignmentList.length; idx++) {
            if (consignmentList[idx].cn_no === json.cn) {
                index = idx;
                break;
            }
        }
        if (index === -1) return;
        let tmp = consignmentList;
        if (json.task === "location") {
            tmp[index].pincode = json.pincode;
            tmp[index].address = json.address;
            tmp[index].country = json.country;
            tmp[index].destination = json.destination;
        } else if (json.task === "weight") {
            tmp[index].weight = json.weight;
            tmp[index].type = json.type;
            tmp[index].method = json.method;
        } else if (json.task === "price") {
            tmp[index].amount = Number(json.amount);
            tmp[index].other = Number(json.other);
            tmp[index].fuel = Number(json.fuel);
            tmp[index].gst = Number(json.gst);
        } else if (json.task === "date") {
            tmp[index].created = json.created;
        } else if (json.task === "delete") {
            tmp.splice(index, 1);
        }
        // console.log(tmp);
        // console.log(tmp[index]);
        setConsignmentList(tmp);
    }
    const handleClose = () => {
        setActiveConsignment(null);
        setFieldtEdit(null);
    };

    const handleTimeChange = (e, start) => {
        if (e.target.value === "") return;
        const _json = { interval: null, start: startTime ?? dateUsaToInd(cu_date), end: endTime ?? dateUsaToInd(cu_date) };
        const n_date = dateUsaToInd(e.target.value);
        if (start) {
            setStartTime(n_date);
            _json["start"] = n_date;
        } else {
            setEndTime(n_date);
            _json["end"] = n_date;
        }
        setConsignmentList([]);
        getAllOrgCn(_json).then((res) => {
            allCns = res;
            setConsignmentList(res);
            setSpanTime("");
        }).catch((err) => {
            allCns = [];
            setConsignmentList([]);
            console.error(err);
        });
    }

    const handleSpanChange = (e) => {
        setSpanTime(e.target.value);
        if (e.target.value === "") return;
        setConsignmentList(false);
        getAllOrgCn({ interval: e.target.value }).then((res) => {
            allCns = res;
            setConsignmentList(res);
        }).catch((err) => {
            allCns = [];
            setConsignmentList([]);
            console.error(err);
        });
    }

    const handleClientChange = (e) => {
        if (allCns === null || e.target.value === "") {
            setConsignmentList(allCns);
            return;
        }
        setConsignmentList(allCns.filter((item) => item.client_id === e.target.value));
    }

    const initData = async (auth) => {
        if (!auth) return;
        try {
            setClientList(await getClientList());
            if (Boolean(params.company)) {
                handleClientChange({ "target": { "value": params.company } });
            }
            allCns = await getAllOrgCn({ interval: spanTime, start: startTime, end: endTime });
            setConsignmentList(allCns);
        } catch (err) {
            console.error(err);
        }
    }
    const searchCn = (e) => {
        const tmp = allCns.filter((itm) => itm.cn_no.startsWith(e.target.value.trim()));
        if (tmp.length === 0) setConsignmentList(allCns);
        else setConsignmentList(tmp);
    }

    return (
        <MenuFrame permission="BOOKING_ORG" onInit={initData} onSearch={searchCn} screen={"ORG_EDIT"}>
            <PriceEdit data={activeConsignment} open={fieldEdit === "price"} handleClose={handleClose} onSuccess={handleEditSuccess} />
            <LocationEdit data={activeConsignment} open={fieldEdit === "location"} handleClose={handleClose} onSuccess={handleEditSuccess} />
            <WeightEdit data={activeConsignment} open={fieldEdit === "weight"} handleClose={handleClose} onSuccess={handleEditSuccess} />
            <DateEdit data={activeConsignment} open={fieldEdit === "date"} handleClose={handleClose} onSuccess={handleEditSuccess} />
            <DeleteConsignment data={activeConsignment} open={fieldEdit === "delete-cn"} handleClose={handleClose} onSuccess={handleEditSuccess} />

            <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <FormControl fullWidth>
                        <InputLabel id="time-span">Span</InputLabel>
                        <Select
                            autoFocus
                            labelId="time-span"
                            id="time-span"
                            label="Time Span"
                            value={spanTime}
                            onChange={handleSpanChange}
                        >
                            <MenuItem value={""}>None</MenuItem>
                            <MenuItem value={"day"}>Day</MenuItem>
                            <MenuItem value={"month"}>Month</MenuItem>
                            <MenuItem value={"last-month"}>Last Month</MenuItem>
                            <MenuItem value={"fy"}>Fiscal Year</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="start_date" type="date" fullWidth defaultValue={getCurrentMonthStart()} slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} placeholder="Start Date" onChange={(e) => { handleTimeChange(e, true) }} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="end_date" type="date" fullWidth defaultValue={cu_date} slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} placeholder="End Date" onChange={(e) => { handleTimeChange(e, false) }} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Autocomplete
                        disablePortal
                        defaultValue={{ "client_id": params.company ?? "", "name": "" }}
                        noOptionsText={<DropDownLoading title="Loading Clients ..." />}
                        onBlur={handleClientChange}
                        options={clientList === null ? [] : clientList}
                        getOptionLabel={(option) => option.client_id}
                        renderOption={(props, option) => {
                            const { key, ...optionProps } = props;
                            return (
                                <Box key={key} component="li" {...optionProps} >
                                    {option.name} ({option.client_id})
                                </Box>
                            );
                        }}
                        renderInput={(params) => <TextField {...params} variant="outlined" name="client" fullWidth type="text" autoFocus placeholder="Client" label="Client" />}
                    />
                </Grid>
            </Grid>
            {consignmentList === null || consignmentList === false ? <Loading1 /> :
                <TableContainer component={Paper}>
                    <Table size="small" stickyHeader aria-label="Consignment" className="nowrap">
                        <TableHead>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { fontWeight: "bold", backgroundColor: "background.th" } }}>
                                <TableCell>Client</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Consignment</TableCell>
                                <TableCell>Destination</TableCell>
                                <TableCell align="right">Weight(Grm)</TableCell>
                                <TableCell align="right">Total</TableCell>
                                <TableCell align="right">Amount</TableCell>
                                <TableCell align="right">Other</TableCell>
                                <TableCell>PPI</TableCell>
                                <TableCell align="right">Fuel</TableCell>
                                <TableCell align="right">GST</TableCell>
                                <TableCell>Entry</TableCell>
                            </TableRow>
                        </TableHead>
                        <ThemeProvider theme={dayTheme}>
                            <TableBody>
                                {consignmentList.length === 0 ? <TableRow><TableCell colSpan={12} style={{ textAlign: "center" }}><Typography variant="subtitle2" color="textDisabled">No data to display</Typography></TableCell></TableRow> : ""}
                                {consignmentList.map((row) => (
                                    <TableRow key={row.cn_no} style={{ background: row.ispaid ? green[50] : row.amount === 0 ? orange[50] : blue[50] }}
                                        onClick={(e) => {
                                            if (activeConsignment !== null && row.cn_no === activeConsignment.cn_no)
                                                handleClose();
                                            else
                                                setActiveConsignment(row);
                                        }}
                                    >
                                        <TableCell>
                                            {row.client_id}
                                            <Collapse in={activeConsignment !== null && activeConsignment.cn_no === row.cn_no}>
                                                <Typography variant="body2">{row.name}</Typography>
                                                <Typography variant="caption">{row.gst_num}</Typography>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell>{row.created} {row.ispaid ? "" : <IconButton onClick={() => { setFieldtEdit("date"); }}><Edit fontSize="small" /></IconButton>}</TableCell>
                                        <TableCell>{row.cn_no} {row.ispaid ? "" : <IconButton onClick={() => { setFieldtEdit("delete-cn"); }}><Delete fontSize="small" /></IconButton>} </TableCell>
                                        <TableCell>
                                            {row.destination === "" ? <Typography variant="caption" color="error">Unknown</Typography> : row.destination} - {row.pincode} {row.ispaid ? "" : <IconButton onClick={() => { setFieldtEdit("location"); }}><Edit fontSize="small" /></IconButton>}
                                            <Collapse in={activeConsignment !== null && activeConsignment.cn_no === row.cn_no}>
                                                <Typography variant="body2">{row.country}</Typography>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell align="right">
                                            {row.ispaid ? "" : <IconButton onClick={() => { setFieldtEdit("weight"); }}><Edit fontSize="small" /></IconButton>} {row.weight}
                                            <Collapse in={activeConsignment !== null && activeConsignment.cn_no === row.cn_no}>
                                                <Typography variant="body2">{row.type} | {row.method}</Typography>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell align="right">{row.ispaid ? <Chip variant="filled" color="success" label="Paid" size="small" /> : <IconButton onClick={() => { setFieldtEdit("price"); }} ><Edit fontSize="small" /></IconButton>} {(row.amount + row.other + row.insurance + row.packaging + row.pickup + row.fuel + row.gst).toFixed(2)}</TableCell>
                                        <TableCell align="right">{row.amount.toFixed(2)}</TableCell>
                                        <TableCell align="right">{row.other.toFixed(2)}</TableCell>
                                        <TableCell>
                                            <Collapse in={activeConsignment === null || activeConsignment.cn_no !== row.cn_no}>
                                                <Chip variant="outlined" size="small" color="success" label={"₹" + (row.insurance + row.packaging + row.pickup)} />
                                            </Collapse>
                                            <Collapse in={activeConsignment !== null && activeConsignment.cn_no === row.cn_no}>
                                                {row.insurance !== 0 ? <><Chip variant="outlined" size="small" label={"₹" + row.insurance + " on insurance*"} /><br /></> : ""}
                                                {row.packaging !== 0 ? <><Chip variant="outlined" size="small" label={"₹" + row.packaging + " on " + row.packaging_count + " packaging"} style={{ cursor: "alias" }} component={Link} href="/packaging-booking" /><br /></> : ""}
                                                {row.pickup !== 0 ? <><Chip variant="outlined" size="small" label={"₹" + row.pickup + " on " + row.pickup_count + " pickup"} style={{ cursor: "alias" }} component={Link} href="/pickup-booking" /></> : ""}
                                            </Collapse>
                                        </TableCell>
                                        <TableCell align="right">{row.fuel.toFixed(2)}</TableCell>
                                        <TableCell align="right">{row.gst.toFixed(2)}</TableCell>
                                        <TableCell><IconButton><AccountCircleTwoTone fontSize="small" color="info" titleAccess={row.entry_person} /></IconButton></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </ThemeProvider>
                    </Table>
                </TableContainer>
            }
            <Typography variant="caption" color="textPrimary">* GST on insurance is already added at 18% rate</Typography>
        </MenuFrame>
    );
}

export default OrgCnEdit;